export const AVAILABLE_TOOLS = [
  'findMembers',
  'searchMembers',
  'searchMessages',
  'multiSearch',
  'rawSearch',
  'searchActivity',
  'searchHotelStays',
  'searchReservations',
  'searchEvents',
  'getFishProfile',
  'lookupFishByPhone',
  'getFishActivity',
  'listTags',
  'listSegments',
  'sendSMS',
  'sendEmail',
  'addTagToFish',
  'createTag',
  'bulkTagFish',
  'tagFishByActivity',
  'createSegment',
  'computeStats',
  'clearBusinessObject',
  'currentDate',
  'queryOmni',
  'buildTicketedEvent',
  'listVenues',
  'getBrainRuns',
  'listFlows',
] as const;

export type AvailableTool = (typeof AVAILABLE_TOOLS)[number];
